export class ShippingPriceDTO {
    priceFrom: number;
    priceTo: number;
    shippingPrice: number;

    public constructor(priceFrom: number, priceTo: number, shippingPrice: number) {
        this.priceFrom = priceFrom;
        this.priceTo = priceTo;
        this.shippingPrice = shippingPrice;
    }
}

